import { AccessStorage } from "../storage/AccessStorage";
import { Request } from "./core/olga/Request";

export class StandaloneCouponsAPI {
  static async request({ endpoint, data = {}, params = {}, method = "get" }) {
    return await Request.request({
      service: "environments/standalone-coupons",
      endpoint: endpoint || "",
      method: method || "get",
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  static async requestAuthenticated({
    endpoint,
    data = {},
    params = {},
    method = "get",
  }) {
    return await Request.request({
      service: "environments/standalone-coupons",
      endpoint: endpoint || "",
      method: method || "get",
      headers: {
        Authorization: `Bearer ${AccessStorage.getAccessToken()}`,
      },
      data: data || {},
      params: params || {},
      ignoreVersion: true,
    });
  }

  static async getStandaloneCoupons(
    status = "ACTIVATED",
    folder = null,
    page = 0,
    limit = 12,
    parentId = null
  ) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: "",
      params: { status, folder, parentId, page, limit },
    });
  }

  static async getAllStandaloneCoupons({
    status = "ACTIVATED",
    grantType = "SYSTEM",
  }) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: "",
      params: {
        status,
        grantType,
        folder: "ALL",
        parentId: null,
        page: null,
        limit: null,
      },
    });
  }

  static async getStandaloneCouponById(couponId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}`,
    });
  }

  static async postStandaloneCoupons(data) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: "",
      method: "post",
      data,
    });
  }

  static async putStandaloneCoupons(data, id) {
    const endpoint = id ? `/${id}` : "";

    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint,
      method: "put",
      data,
    });
  }

  static async createChildrenCoupon(couponId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}/childrens`,
      method: "post",
    });
  }

  static async assignStandaloneCoupons(couponId, customersPhone) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}/assign`,
      method: "post",
      data: { customersPhone },
    });
  }

  static async putStandaloneCouponStatus(couponId, status) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}/status`,
      method: "put",
      data: { status },
    });
  }

  static async updateCouponFolder(couponId, folderId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}/folders/${folderId}`,
      method: "put",
    });
  }

  static async deleteCouponFolder(couponId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/${couponId}/folders`,
      method: "delete",
    });
  }

  static async moveFolder(sourceFolderId, destinationFolderId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/folders/${sourceFolderId}`,
      method: "put",
      data: {
        destinationFolderId,
      },
    });
  }

  static async deleteFolder(folderId) {
    return StandaloneCouponsAPI.requestAuthenticated({
      endpoint: `/folders/${folderId}`,
      method: "delete",
    });
  }
}
